import {
  Alert,
  Badge,
  Button,
  Checkbox,
  Descriptions,
  Icons,
  Modal,
  TextField,
} from '@pankod/refine-antd'
import React, { useState } from 'react'
import dayjs from 'dayjs'
import clsx from 'clsx'

import {
  PROGRAM_LOCAL_STATE,
  PROGRAM_LOCAL_STATE_LABEL,
  PROGRAM_LOCAL_BADGE_COLOR,
  TLMSProgramLocal,
} from '../types'
import { getNextProgramLocalState } from '@resources/lms-management/program-lokal/utils'

const ProgramLocalDetail = ({
  data,
  onUpdateStatus,
  canUpdateStatus,
  isUpdatingStatus,
}: {
  data?: TLMSProgramLocal
  onUpdateStatus: () => void
  canUpdateStatus: boolean
  isUpdatingStatus: boolean
}) => {
  const nextState = getNextProgramLocalState(
    data?.status || PROGRAM_LOCAL_STATE.DRAFT,
  )
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isConfirmed, setIsConfirmed] = useState(false)

  const handleOpenModal = () => {
    setIsConfirmed(false)
    setIsModalVisible(true)
  }

  const handleConfirm = () => {
    setIsModalVisible(false)
    onUpdateStatus()
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  return (
    <>
      <Descriptions
        bordered
        size="small"
        column={2}
        className="mb-6"
        labelStyle={{ fontWeight: 600 }}
      >
        <Descriptions.Item span={2} label="ID">
          {data?.id}
        </Descriptions.Item>
        <Descriptions.Item span={2} label="Nama">
          {data?.name}
        </Descriptions.Item>
        <Descriptions.Item label="Periode">
          {data?.startDate && data?.endDate ? (
            <>
              {dayjs(data?.startDate).format('DD MMM YYYY')} &mdash;{' '}
              {dayjs(data?.endDate).format('DD MMM YYYY')}
            </>
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <div className="flex flex-col gap-1">
            <div className="flex gap-1 mb-1">
              <Badge
                status={
                  PROGRAM_LOCAL_BADGE_COLOR[
                    data?.status || PROGRAM_LOCAL_STATE.DRAFT
                  ]
                }
                className={clsx(
                  data?.status !== PROGRAM_LOCAL_STATE.DONE &&
                    'animate-[1s_pulse_infinite]',
                )}
              />
              <div className="mr-5 font-bold">
                {
                  PROGRAM_LOCAL_STATE_LABEL[
                    data?.status || PROGRAM_LOCAL_STATE.DRAFT
                  ]
                }
              </div>
            </div>
            <Button
              size="small"
              icon={<Icons.DoubleRightOutlined />}
              disabled={
                !canUpdateStatus ||
                isUpdatingStatus ||
                nextState === PROGRAM_LOCAL_STATE.DRAFT
              }
              loading={isUpdatingStatus}
              type="primary"
              className="!max-w-fit"
              onClick={handleOpenModal}
            >
              Ubah status
            </Button>
            <Modal
              title="Konfirmasi Perubahan Status"
              visible={isModalVisible}
              onOk={handleConfirm}
              onCancel={handleCancel}
              okText="Lanjutkan"
              cancelText="Batal"
              okButtonProps={{
                disabled: !isConfirmed || isUpdatingStatus,
                loading: isUpdatingStatus,
              }}
              cancelButtonProps={{
                disabled: isUpdatingStatus,
              }}
            >
              <div className="flex flex-col gap-4">
                <p className="mb-0">
                  Apakah Anda yakin ingin mengubah status program lokal menjadi{' '}
                  <strong>{PROGRAM_LOCAL_STATE_LABEL[nextState]}</strong>?
                </p>

                {nextState === PROGRAM_LOCAL_STATE.DONE && (
                  <Alert
                    type="warning"
                    showIcon
                    message="Perhatian"
                    description="Pastikan kembali data sertifikat untuk peserta sudah akurat sebelum menyelesaikan program lokal."
                  />
                )}

                <Checkbox
                  checked={isConfirmed}
                  onChange={(e) => setIsConfirmed(e.target.checked)}
                >
                  Saya mengonfirmasi perubahan status ini
                </Checkbox>
              </div>
            </Modal>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label="Provinsi" span={2}>
          {data?.provinsi ? (
            data?.provinsi
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Kota/Kabupaten">
          {data?.kotaKab ? (
            data?.kotaKab
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Kecamatan">
          {data?.kecamatan ? (
            data?.kecamatan
          ) : (
            <TextField value="Kosong" disabled italic />
          )}
        </Descriptions.Item>
      </Descriptions>
    </>
  )
}

export default ProgramLocalDetail
